import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Button, Menu, MenuItem, Fade, Avatar } from "@material-ui/core";
import onClickOutside from 'react-onclickoutside'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import TextField from '@material-ui/core/TextField';
import DashboardApi from '../../../../app/api/Scoreboardapi';
import * as allOptions from '../../../../app/pages/home/TopbarStaticOptions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import clsx from "clsx";
import LeftMenuMobile from "../../../../app/pages/home/LeftMenuMobile";
// import * as auth from "../../store/ducks/auth.duck";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
// import Autocomplete from "AutoComplete"
import * as auth from "../../../../app/store/ducks/auth.duck";
import { Multiselect } from "multiselect-react-dropdown";
import { referralParamsSubscriber } from '../../../../app/services/dataTransferService'
import UserCreateApi from "../../../../app/api/Scoreboardapi";
import { checkModulePermission } from "../../../../app/crud/auth.crud";
library.add(fas)
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "white"
  },
}));


function UserProfilePic(props) {
  let username = props.username
  let matches = username.match(/\b(\w)/g);
  username = matches.join('');
  if (props.imgPath) {
    return <Avatar variant="square" alt={props.username} src={process.env.REACT_APP_API_IMAGE_URL + props.imgPath} />
  }
  return <span className="bg-success text-white g-avatar">{username}</span>;
}
const renderField = ({
  input,
  label,
  type,
  meta: { asyncValidating, touched, error }
}) => (
  <div className="formgroup">
    <label className="custom-label">{label}</label>
    <div className={asyncValidating ? 'async-validating' : ''}>
      <input {...input} type={type} placeholder={label} className="form-control" />
      {touched && error && <span className="error-msg">{error}</span>}
    </div>
  </div>
)
class Topbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      isShowFilter: false,
      searchParamsDoctor: '',
      doctorOptions: '',
      insuranceOptions: this.props.insuranceOptions,
      salesRepOptions: this.props.salesRepresentativesResponse,
      orderStatusOptions: [],
      doctorOptionLoading: false,
      complianceStatus: [],
      diagnosis: [],
      doctor: [],
      daySinceSetup: '',
      patientFirstName: '',
      patientLastName: '',
      voidReason: [],
      salesRep: [],
      equipmentType: [],
      startDate: '',
      endDate: '',
      dob: '',
      orderStatus: [],
      maskType: [],
      screenerFollowUpStatus: [],
      insurance: [],
      PayorSuggestionList: [],
      isreferralNameSearch: false,
      referralName: '',
      newReferralKey: '',
      referralNameArray: [],
      isLoadingReferral: false,
      selectedReferralNameValues: '',
      showSearch: true,
      showText: false,
      nickName: "",
      selectedReferral: [],
      isLeftMenuVisible: false,
      breakdownClass: '',
      trendsClass: '',
      detailsClass: '',
      isOpen: true,
      isSalesRepresentativesApiCall: true,
      sleepScreenerAccess: '',
      globalSummaryAccess: '',
      maskTypeOptions: this.props.maskTypeOptions,
    }

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.handleGo = this.handleGo.bind(this);
  };

  toggleLeftMenuDesktop = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }


  state = {
    anchorEl: null,
    PayorSuggestionList: [],
    isreferralNameSearch: false,
    referralName: '',
    newReferralKey: '',
  };

  handleClick = (event) => {
    if (this.state.anchorEl == null) {
      this.setState({ anchorEl: event.currentTarget });
    } else {
      this.setState({ anchorEl: null });
    }
  };

  handleChange = (e) => {
    if (e.length >= 3) {
      this.setState({ isLoadingReferral: true });
      this.props.fetchreferralNameRequest(e);
    }
  }
  onSelect = (selectedList, selectedItem) => {
    this.setState({
      selectedReferralNameValues: this.state.selectedReferralNameValues == "" ? selectedItem.referralKey.toString() : this.state.selectedReferralNameValues.toString() + ',' + selectedItem.referralKey.toString(),
      nickName: selectedItem.nickName,
      selectedReferral: this.state.selectedReferral.concat(selectedItem.referral),
    });
  }
  onRemove = (selectedList, removedItem) => {
    var data = this.state.selectedReferralNameValues.split(',')
    data.splice(data.indexOf(removedItem.referralKey), 1);
    var selectedReferralData = this.state.selectedReferral;
    // selectedReferralData.splice(data.indexOf(removedItem.referral), 1);
    var index = selectedReferralData.indexOf(removedItem.referral);
    if (index !== -1) {
      selectedReferralData.splice(index, 1);
    }
    this.setState({
      selectedReferralNameValues: data.join(','),
      selectedReferral: selectedReferralData,
    });
  }
  getSuggestionValue(suggestion) {
    if (suggestion && suggestion.ReferralKey)
      localStorage.setItem('newReferralKey', suggestion.ReferralKey);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.salesRepresentativesResponse && nextProps.salesRepresentativesResponse.length > 0) {
      this.setState({ salesRepOptions: nextProps.salesRepresentativesResponse})
    }

    var moduleName = window.location.href.split("/").pop();
    this.setState({ isScreenedPatient: moduleName == 'screened-patient' })

    let filteredReferralNameResponse = [];
    if (nextProps.referralNameResponse !== undefined) {
      filteredReferralNameResponse = nextProps.referralNameResponse.liGetReferralSearch && nextProps.referralNameResponse.liGetReferralSearch.filter(function (e) {
        return e.referralKey !== 0;
      });
    }

    if (nextProps.referralNameResponse != undefined && nextProps.referralNameResponse.liGetReferralSearch != null) {
      this.setState({
        PayorSuggestionList: nextProps.referralNameResponse == undefined ? [] : nextProps.referralNameResponse.liGetReferralSearch,
        referralNameArray: nextProps.referralNameResponse == undefined ? [] : filteredReferralNameResponse,
      });
    }
    if (nextProps.referralNameResponse) {
      if (nextProps.referralNameResponse && nextProps.referralNameResponse != this.props.referralNameResponse) {
        this.setState({ isLoadingReferral: nextProps.isLoadingReferral });
      }
    }

    if (moduleName == 'screened-patient' && this.state.isSalesRepresentativesApiCall) {
        this.props.fetchSalesRepresentativesRequest();
        this.setState({ isSalesRepresentativesApiCall: false });
    }

    if ((nextProps.checkForMenuItemAccess.success != undefined && nextProps.checkForMenuItemAccess.success == true)) {
      this.setState({sleepScreenerAccess: nextProps.checkForMenuItemAccess.sleepScreenerAccess});
      this.setState({globalSummaryAccess: nextProps.checkForMenuItemAccess.globalSummaryAccess});
    }

  }
  toggleDropdown() {
    this.setState({ anchorEl: !this.state.anchorEl });
  }
  handleClickOutside() {
    this.setState({ anchorEl: null })
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleModalShowHide = () => {
    this.setState({ isShowFilter: !this.state.isShowFilter })
  }
  handleResetForm = () => {
    this.setState({
      complianceStatus: [],
      diagnosis: [],
      doctor: [],
      daySinceSetup: '',
      patientFirstName: '',
      patientLastName: '',
      voidReason: [],
      salesRep: [],
      equipmentType: [],
      startDate: '',
      endDate: '',
      dob: '',
      insurance: [],
      orderStatus: [],
      maskType: [],
      screenerFollowUpStatus: [],
      isShowFilter: false
    })
    if (!this.state.isScreenedPatient) {
      const formData = {
        salesRepParam: '',
        doctorParam: '',
        doctorNameParam: '',
        doctorFirstNameParam: '',
        doctorLastNameParam: '',
        insuranceParam: '',
        maskTypeParam: '',
        complianceRiskParam: '',
        equipmentTypeParam: '',
        daysSinceSetupParam: '',
        organizationParam: this.props.organizationParam,
        referralParam: this.props.referralParam,
        startDate: '',
        endDate: '',
        patientNameParam: '',
        patientFirstNameParam: '',
        patientNameLastParam: '',
        dateOfBirthParam: '',
        pageSize: 20,
        pageNo: 1
      };
      if (this.props.isPapUser == 1)
        this.props.fetchSalesOrderFilterListRequest(formData)
      else {
        this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
          ReferralParam: JSON.parse(localStorage.getItem('persist:userData')).referralParam.replace(/"/g, ''),
          IsStatusNameParam: false,
          StatusNameParam: ""
        });
      }
    }
    else {
      const formData = {
        Organization: this.props.organizationParam,
        ReferralParam: this.props.referralParam,
        PatientFirstName: '',
        PatientLastName: '',
        SalesRep: '',
        DateOfBirth: '',
        FollowUpStatus: ''
      }
      this.props.fetchScreenedPatientListRequest(formData);

    }

    this.props.saveSalesFilter([], true)
    this.props.clearFilter({
      "isFilterClear": true,
    });

  }
  handleGo = () => {
    var selectedReferral = '';
    if (this.state.selectedReferralNameValues != '') {
      var splitselectedReferral = this.state.selectedReferralNameValues.split(',');
      if (splitselectedReferral.length > 1) {
        selectedReferral = splitselectedReferral.length + ' Referrals';
      }
      else if (splitselectedReferral.length === 1) {
        selectedReferral = this.state.selectedReferral[0];
      }
    }
    referralParamsSubscriber.next(this.state.selectedReferralNameValues ? this.state.selectedReferralNameValues : this.props.referralParam);
    // if (this.state.nickName !== "") {
    this.setState({
      showText: (selectedReferral != '') ? true : false,
      showSearch: (selectedReferral == '') ? true : false,
      nickName: selectedReferral,
    });
    // }
  }
  handleGoBack = () => {
    this.setState({
      showSearch: this.state.showSearch === true ? false : true,
      showText: this.state.showText === true ? false : true

    });
  }

  handleChangeInput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleSelectChange = (field, value, reason) => {
    this.setState({
      [field]: value
    })
  }
  handleFormSubmit(event) {
    event.preventDefault();
    this.setState({ submitBtnDisabled: true });
    this.props.fetchFilterList();
    let insuranceParam = this.state.insurance.map(function (item) { return item['value']; }).join('||')
    let maskTypeParam = this.state.maskType.map(function (item) { return item['value']; }).join()
    let equipmentTypeParam = this.state.equipmentType.map(function (item) { return item['value']; }).join()
    let voidReasonParam = this.state.voidReason.map(function (item) { return item['value']; }).join()
    let doctorParam = this.state.doctor.map(function (item) { return item['value']; }).join('||')
    let orderStatusParam = this.state.orderStatus.map(function (item) { return item['value']; }).join()
    let salesRepParam = this.state.salesRep.map(function (item) { return item['value']; }).join('||')
    let screenerFollowUpStatusParam = this.state.screenerFollowUpStatus.map(function (item) { return item['value']; }).join()
    if (!this.state.isScreenedPatient) {
      if (this.props.isPapUser == 1) {
        const formData = {
          statusParam: orderStatusParam,
          salesRepParam: salesRepParam,
          doctorParam: doctorParam,
          doctorNameParam: doctorParam,
          doctorFirstNameParam: doctorParam,
          doctorLastNameParam: doctorParam,
          insuranceParam,
          maskTypeParam,
          complianceRiskParam: this.state.complianceStatus,
          equipmentTypeParam,
          daysSinceSetupParam: this.state.daySinceSetup,
          organizationParam: this.props.organizationParam,
          referralParam: this.props.referralParam,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          voidReasonParam,
          patientNameParam: this.state.patientFirstName,
          patientFirstNameParam: this.state.patientFirstName,
          patientNameLastParam: this.state.patientLastName,
          dateOfBirthParam: this.state.dob,
          rowsToSkip: 0,
        };
        this.props.fetchSalesOrderFilterListRequest(formData)
      }
      else {
        const formData = {
          "statusParam": orderStatusParam,
          "StartDate": this.state.startDate,
          "EndDate": this.state.endDate,
          "PatientNameParam": this.state.patientFirstName,
          "PatientFirstNameParam": this.state.patientFirstName,
          "PatientLastNameParam": this.state.patientLastName,
          "DateOfBirthParam": this.state.dob,
          "OrganizationParam": this.props.organizationParam,
          "ReferralParam": this.props.referralParam,
          "DoctorsParam": doctorParam,
          "DoctorNameParam": doctorParam,
          "DoctorFirstNameParam": doctorParam,
          "DoctorLastNameParam": doctorParam,
          "InsuranceParam": insuranceParam,
          "ComplianceRiskParam": this.state.complianceStatus,
          "EquipmentTypeParam": equipmentTypeParam,
          "LimitParam": 1000,
          "OffsetParam": 0
        }
        this.props.fetchNonPAPSalesListByFilterRequest(formData)
      }
    }
    else{
      const formData = {
        Organization: this.props.organizationParam,
        ReferralParam: this.props.referralParam,
        PatientFirstName: this.state.patientFirstName,
        PatientLastName: this.state.patientLastName,
        SalesRep: salesRepParam,
        DateOfBirth: this.state.dob,
        FollowUpStatus: screenerFollowUpStatusParam,
        IsAdmin : JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName == "super-admin" ? 1 : 0
      }

      this.props.fetchScreenedPatientListRequest(formData);
    }

    let salesFilterList = []
    if (this.state.patientFirstName)
      salesFilterList.push({ name: 'Patient First Name', value: this.state.patientFirstName })

    if (this.state.patientLastName)
      salesFilterList.push({ name: 'Patient Last Name', value: this.state.patientLastName })

    if (insuranceParam)
      salesFilterList.push({ name: 'insurance', value: insuranceParam })


    if (orderStatusParam)
      salesFilterList.push({ name: 'Order Status', value: orderStatusParam })

    if (voidReasonParam)
      salesFilterList.push({ name: 'Void reason', value: voidReasonParam })

    if (doctorParam)
      salesFilterList.push({ name: 'doctor', value: doctorParam })

    if (salesRepParam)
      salesFilterList.push({ name: 'Sales Rep', value: salesRepParam })


    if (equipmentTypeParam)
      salesFilterList.push({ name: 'Equipment Type', value: equipmentTypeParam })

    if (screenerFollowUpStatusParam)
      salesFilterList.push({ name: 'Screener Follow-Up Status', value: screenerFollowUpStatusParam })

    if (this.state.startDate)
      salesFilterList.push({ name: 'Create Date Form', value: this.state.startDate })

    if (this.state.endDate)
      salesFilterList.push({ name: 'Create Date To', value: this.state.endDate })

    if (this.state.dob)
      salesFilterList.push({ name: 'Date of Birth', value: this.state.dob })

    if (this.state.complianceStatus && this.state.complianceStatus != '')
      salesFilterList.push({ name: 'Compliance Status', value: this.state.complianceStatus })

    if (this.state.diagnosis && this.state.diagnosis != '')
      salesFilterList.push({ name: 'Diagnosis', value: this.state.diagnosis })

    if (this.state.daySinceSetup)
      salesFilterList.push({ name: 'Days since Setup', value: this.state.daySinceSetup })

    if (maskTypeParam)
      salesFilterList.push({ name: 'Mask Type', value: maskTypeParam })

    this.props.saveSalesFilter(salesFilterList, true)
    this.setState({ isShowFilter: false })
  }
  getDoctorList = (e) => {
    this.setState({
      searchParamsDoctor: e.target.value
    })
    if (e.target.value && e.target.value.length > 3) {
      const options = {
        params: {
          "DoctorName": e.target.value
        }

      }
      this.setState({
        doctorOptions: [{ label: "Please enter at least 4 characters", value: "Please enter at least 4 characters" }],
        doctorOptionLoading: true
      })
      DashboardApi.get('dashboard/getdoctorlist', options)
        .then((res) => res.data.listDoctorResponse ? res.data.listDoctorResponse.map((option) => ({
          'value': option.doctorName,
          'label': option.doctorName
        })) : []
        )
        .then(doctorOptions =>
          this.setState({
            doctorOptions,
            doctorOptionLoading: false
          }))
    }
  }

  backToAccount = async (email, event) => {
    let previousUser = JSON.parse(localStorage.getItem('previousUser'));
    await this.props.login(previousUser);
    await localStorage.setItem("prevLoggedInEmail", '')
    localStorage.setItem("loadNewReferralParam", 1)
    setTimeout(() => { this.props.history.push('/users') }, 2000);
  }

  hideShowLeftDashboardMenu = () => {
    this.setState({
      isLeftMenuVisible: !this.state.isLeftMenuVisible
    })
  }

  // scrollToBreakDown = (divIdToScroll) => {
  //   var activClassJson = {
  //     breakdownClass: '',
  //     trendsClass: '',
  //     detailsClass: '',
  //   };

  //   if (divIdToScroll == 'breakdown') {
  //     activClassJson.breakdownClass = 'active';
  //   }
  //   else if (divIdToScroll == 'trends') {
  //     activClassJson.trendsClass = 'active';
  //   }
  //   else {
  //     activClassJson.detailsClass = 'active';
  //   }
  //   this.setState(activClassJson);

  //   const element = document.getElementById(divIdToScroll);
  //   if (element) {      
  //     // window.scrollTo({
  //     //   top: element.offsetTop,
  //     //   behavior: 'smooth'
  //     // })
  //     // var headerEle = document.getElementsByTagName("header")[0];
  //     // var elementPosition = element.getBoundingClientRect().top;
  //     // var offsetPosition = elementPosition + (headerEle.offsetTop);

  //     // window.scrollTo({
  //     //   top: offsetPosition,
  //     //   behavior: "smooth"
  //     // });
  //     element.scrollIntoView({behavior: "smooth"})
  //   }    
  // }

  scrollToBreakDown = (divIdToScroll) => {
    // document.getElementById(divIdToScroll).scrollIntoView({behavior: 'smooth'});
    var activClassJson = {
      breakdownClass: '',
      trendsClass: '',
      detailsClass: '',
    };

    if (divIdToScroll == 'breakdown') {
      activClassJson.breakdownClass = 'active';
    }
    else if (divIdToScroll == 'trends') {
      activClassJson.trendsClass = 'active';
    }
    else {
      activClassJson.detailsClass = 'active';
    }
    this.setState(activClassJson);

    const element = document.getElementById(divIdToScroll);
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  render() {
    if (this.props.isFilterClear) {
      this.handleResetForm();
      this.props.clearFilter({
        "isFilterClear": false,
      });
    }

    let dashboardMsg = '';
    if (localStorage.getItem('prevLoggedInEmail')) {
      dashboardMsg = (<p className="search-text text-center m-0" style={{ color: "#fff !important" }}>Logged in as {this.props.userFirstName}, click <a href="javascript:void(0)" onClick={(e) => this.backToAccount(localStorage.getItem('prevLoggedInEmail'), e)}>
        here</a> to return to your account</p>);
    }

    const { anchorEl } = this.state;
    const { plainArray, referralNameArray, selectedValues } = this.state;
    // this.setInsuranceOption()
    // this.setSalesRepoOption()
    let username = this.props.userFirstName
    let matches = username.match(/\b(\w)/g);
    username = matches.join('');

    var leftMenuVisibleClass = '';
    var openIconClass = 'hide-icon-for-left-menu';
    var dashboardRightContentClass = "collapse-dashboard"
    var dashboardLeftMenuVisibleClass = 'hide-leftmenu';
    if (this.state.isOpen) {
      var leftMenuVisibleClass = 'show';
      var openIconClass = 'show-icon';
      var dashboardRightContentClass = 'expand-dashboard';
      var dashboardLeftMenuVisibleClass = 'show-leftmenu';
    }

    return (
      <>
        <header className="topbar">
          {dashboardMsg}
          <div className="container-fluid menu-container">
            <div className="row jc-between dashboard-menu-desktop">
              <div className="logo">
                <a href="/dashboard">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/referral-new-logo-topbar.png`}
                    className="img-fluid" />
                </a>
              </div>

              <div className="search form-inline">
                {/* {(JSON.parse(localStorage.getItem("previousUser")).liUserResponse[0].roleId == 1 ||
                  JSON.parse(localStorage.getItem("previousUser")).liUserReferralResponse.length > 1 ||
                  JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).referralParam).split(',').length > 1) //this.props.fullDataAccess &&
                //(JSON.parse(localStorage.getItem("previousUser")).liUserResponse[0].roleId == 1)                  ||
                  
                  */}

                {
                  (JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleId != 1 &&
                    (JSON.parse(localStorage.getItem("persist:userData")).referralParam != undefined ?
                      JSON.parse(localStorage.getItem("persist:userData")).referralParam.split(',').length : 0) > 1 ||
                    (JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user)).roleId == 1)

                  && (this.props.location.pathname == '/dashboard' || this.props.location.pathname == '/screened-patient') &&

                  <div style={{ display: this.state.showSearch == true ? "inline-flex" : "none", padding: 0 }}>
                    <div className={`formgroup multiselect select-referral ${clsx(
                      {
                        "refferal-loader": this.state.isLoadingReferral
                      }
                    )}`} >
                      <Multiselect placeholder="Search for Doctor or Facility" options={referralNameArray} className="multiselect" displayValue="referral" onSearch={this.handleChange} onSelect={this.onSelect} onRemove={this.onRemove} emptyRecordMsg="Please enter 3 or more characters" />
                    </div>
                    <button
                      type="submit"
                      disabled={false}
                      onClick={this.handleGo}
                      className={`btn btn-primary btn-elevate kt-login__btn-primary`}
                    >
                      GO
                </button>
                  </div>}
                {(this.props.location.pathname == '/dashboard' || this.props.location.pathname == '/screened-patient') &&
                  <div className="formgroup " style={{ display: this.state.showText == true ? "inline-flex" : "none" }}>
                    <span style={{ color: "white", textAlign: "center" }} > Filtered By:  <strong>{this.state.nickName}</strong>.<a style={{ color: "lightblue" }} onClick={this.handleGoBack}> Edit</a></span>
                  </div>
                }
              </div>
              <div className="user-name">
                {(this.props.location.pathname == '/dashboard' || this.props.location.pathname == '/screened-patient') &&
                  <button className="btn btn-link filter" aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleModalShowHide}>
                    <FontAwesomeIcon icon={["fa", "filter"]} />
                                Filters
                    </button>}
                <Modal
                  className="sales-filters"
                  show={this.state.isShowFilter}
                  onHide={this.handleModalShowHide}
                  backdrop="static"
                  keyboard={false}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"

                >
                  <Modal.Header closeButton>
                    <Modal.Title> <FontAwesomeIcon icon={["fa", "filter"]} /><span
                      className="ml-1 mr-4"><b>Filters</b></span>
                    </Modal.Title>
                  </Modal.Header>
                  <form onSubmit={this.handleFormSubmit}>
                    <Modal.Body>
                      <div className="form-group">
                        <div className="row" style={{ marginTop: '20px' }}>

                          <div className="col-md-6 col-lg-4 filter-form-padding">
                            <span className="filter-form-feilds">Patient First Name</span>
                            <input type="text"
                              className="form-control"
                              name="patientFirstName"
                              value={this.state.patientFirstName}
                              placeholder="Patient First Name"
                              onChange={this.handleChangeInput}
                            />

                          </div>

                          <div className="col-md-6 col-lg-4 filter-form-padding">
                            <span className="filter-form-feilds">Patient Last Name</span>
                            <input type="text"
                              name="patientLastName"
                              value={this.state.patientLastName}
                              className="form-control"
                              placeholder="Patient Last Name"
                              onChange={this.handleChangeInput}
                            />
                          </div>

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Insurance     &nbsp; &nbsp; &nbsp; &nbsp;    </span>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect={true}
                                style={{ padding: '0px', outline: 'none' }}
                                getOptionLabel={(option) => option.label}
                                options={this.props.insuranceOptions}
                                getOptionSelected={(option, value) => option.value == value.value}
                                value={this.state.insurance}
                                onChange={(e, value, reason) => this.handleSelectChange('insurance', value, reason)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Please select insurance"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}

                              />
                            </div>
                          }



                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Order Status</span>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect={true}
                                style={{ padding: '0px', outline: 'none' }}
                                getOptionLabel={(option) => option.label}
                                options={allOptions.orderStatusOptionsStatic ? allOptions.orderStatusOptionsStatic : this.state.options}
                                onChange={(e, value, reason) => this.handleSelectChange('orderStatus', value, reason)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                                value={this.state.orderStatus}
                              />
                            </div>
                          }
                          {
                            !this.state.isScreenedPatient && this.props.isPapUser == 1 ?
                              <div className="col-md-6 col-lg-4 filter-form-padding">
                                <span className="filter-form-feilds">Void reason  &nbsp;   &nbsp; &nbsp;</span>
                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect={true}
                                  style={{ padding: '0px', outline: 'none' }}
                                  getOptionLabel={(option) => option.label}
                                  options={allOptions.voidReason ? allOptions.voidReason : []}
                                  value={this.state.voidReason}
                                  onChange={(e, value, reason) => this.handleSelectChange('voidReason', value, reason)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      placeholder="Please select void Reason"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <React.Fragment>
                                            {params.InputProps.endAdornment}
                                          </React.Fragment>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              : ''
                          }

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Doctor    &nbsp; &nbsp; &nbsp; &nbsp;     &nbsp; &nbsp; &nbsp;                   </span>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect={true}
                                style={{ padding: '0px', outline: 'none' }}
                                getOptionLabel={(option) => option.label}
                                getOptionDisabled={(option) => option.value === 'noData'}
                                options={this.state.doctorOptions && this.state.doctorOptions.length > 0 ? this.state.doctorOptions : allOptions.optionsNoDataParams}
                                loading={this.state.doctorOptionLoading}
                                onInputChange={this.getDoctorList}
                                value={this.state.doctor}
                                onChange={(e, value, reason) => this.handleSelectChange('doctor', value, reason)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Enter at least 4 character"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                    value={this.state.searchParamsDoctor}
                                  />
                                )}

                              />
                            </div>
                          }

                          {
                            this.props.isPapUser == 1 ?
                              <div className="col-md-6 col-lg-4 filter-form-padding">
                                <span className="filter-form-feilds">Sales Rep  &nbsp;   &nbsp; &nbsp; &nbsp;   &nbsp; &nbsp;</span>
                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect={true}
                                  style={{ padding: '0px', outline: 'none' }}
                                  getOptionLabel={(option) => option.label}
                                  options={this.state.salesRepOptions ? this.state.salesRepOptions : []}
                                  value={this.state.salesRep}
                                  onChange={(e, value, reason) => this.handleSelectChange('salesRep', value, reason)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      placeholder="Select"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <React.Fragment>
                                            {params.InputProps.endAdornment}
                                          </React.Fragment>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              </div> : ''}

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Equipment Type</span>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect={true}
                                style={{ padding: '0px', outline: 'none' }}
                                getOptionLabel={(option) => option.label}
                                options={allOptions.equipmentType ? allOptions.equipmentType : []}
                                value={this.state.equipmentType}
                                onChange={(e, value, reason) => this.handleSelectChange('equipmentType', value, reason)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Please select equipment type"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </div>
                          }

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Create Date Form</span>
                              <TextField
                                name="startDate"
                                // style={{width: 201}}
                                id="date"
                                variant="outlined"
                                type="date"
                                format="MM/DD/YYYY"
                                value={this.state.startDate}
                                onChange={(e) => this.setState({ startDate: e.target.value })}
                              />
                            </div>
                          }

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Create Date To</span>
                              <TextField
                                name="endDate"
                                // style={{width: 201}}
                                id="date"
                                variant="outlined"
                                type="date"
                                format="MM/DD/YYYY"
                                value={this.state.endDate}
                                onChange={(e) => this.setState({ endDate: e.target.value })}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                          }

                          {
                            !this.state.isScreenedPatient && this.props.isPapUser == 1 ?
                              <div className="col-md-6 col-lg-4 filter-form-padding">
                                <span className="filter-form-feilds">Days since Setup</span>
                                <input type="number"
                                  className="form-control"
                                  name="daySinceSetup"
                                  placeholder="Days since Setup"
                                  value={this.state.daySinceSetup}
                                  onChange={this.handleChangeInput}
                                />
                              </div> : ''}

                          {
                            !this.state.isScreenedPatient && this.props.isPapUser == 1 ?
                              <div className="col-md-6 col-lg-4 filter-form-padding">
                                <span className="filter-form-feilds">Mask Type  &nbsp;   &nbsp; &nbsp;</span>
                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect={true}
                                  style={{ padding: '0px', outline: 'none', color: 'red' }}
                                  getOptionLabel={(option) => option.label}
                                  options={this.props.maskTypeOptions}
                                  getOptionSelected={(option, value) => option.value == value.value}
                                  value={this.state.maskType}
                                  onChange={(e, value, reason) => this.handleSelectChange('maskType', value, reason)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      placeholder="Please select mask type"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <React.Fragment>
                                            {params.InputProps.endAdornment}
                                          </React.Fragment>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              </div> : ''}

                          <div className="col-md-6 col-lg-4 filter-form-padding">
                            <span className="filter-form-feilds">Date of Birth  &nbsp;   &nbsp; &nbsp;</span>
                            <TextField
                              name="dob"
                              // style={{width: 201}}
                              id="date"
                              variant="outlined"
                              type="date"
                              format="MM/DD/YYYY"
                              value={this.state.dob}
                              onChange={(e) => this.setState({ dob: e.target.value })}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Compliance Status</span>
                              <input type="text" value={this.state.complianceStatus}
                                name="complianceStatus"
                                className="form-control"
                                placeholder="Compliance Status"
                                onChange={this.handleChangeInput}
                              />
                            </div>
                          }

                          {!this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Diagnosis  &nbsp;   &nbsp; &nbsp; &nbsp;   &nbsp; &nbsp;</span>
                              <input type="text"
                                name="diagnosis" value={this.state.diagnosis}
                                className="form-control"
                                placeholder="Diagnosis"
                                onChange={this.handleChangeInput}
                              />
                            </div>
                          }

                          {this.state.isScreenedPatient &&
                            <div className="col-md-6 col-lg-4 filter-form-padding">
                              <span className="filter-form-feilds">Screener Follow-Up Status &nbsp;   &nbsp; &nbsp; &nbsp;</span>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect={true}
                                style={{ padding: '0px', outline: 'none', color: 'red', width:'145%' }}
                                getOptionLabel={(option) => option.label}
                                options={allOptions.optionsScreenerFollowUpStatus ? allOptions.optionsScreenerFollowUpStatus : []}
                                getOptionSelected={(option, value) => option.value == value.value}
                                value={this.state.screenerFollowUpStatus}
                                onChange={(e, value, status) => this.handleSelectChange('screenerFollowUpStatus', value, status)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <React.Fragment>
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}

                                  />
                                )}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>

                      <Button type="submit" className={`btn btn-primary apply-filter`}>Filter</Button>
                      <Button type="reset" onClick={this.handleResetForm} className={`btn btn-secondary remove-filter`}>Remove Filter</Button>
                      <Button onClick={this.handleModalShowHide} className={`btn btn-secondary close-filter-popup`}> Close</Button>
                    </Modal.Footer>
                  </form>
                </Modal>

                 Hello,
                <button className="btn btn-link user-name-link"
                  aria-controls="simple-menu" aria-haspopup="true"
                  onClick={this.handleClick}>{this.props.userFirstName}</button>

                <div className="menu-toggle-icon">
                  <i className="fas fa-ellipsis-h"></i></div>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  keepMounted
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                  onExit={() => {
                    document.body.classList.remove('user-menu-open');
                  }}
                  onEnter={() => {
                    document.body.classList.add('user-menu-open');
                  }}
                  variant="menu"
                >
                  <MenuItem className="user-details">
                    <div className="m-dropdown__header text-center">
                      <div className="m-card-user m-card-user--skin-dark">
                        <div className="m-card-user__pic">
                          {/* <UserProfilePic imgPath={this.props.imgPath} username={this.props.userFirstName} /> */}
                          {
                            this.props.imgPath ?
                              <img alt={this.props.userFirstName} src={process.env.REACT_APP_API_IMAGE_URL + this.props.imgPath} /> :
                              <span className="bg-success text-white g-avatar">{username}</span>
                          }
                        </div>
                        <div className="m-card-user__details">
                          <span className="m-card-user__name m--font-weight-500">{this.props.userFirstName}</span>
                          <a href="mailto:{this.props.email}" className="m-card-user__email m--font-weight-300 m-link">
                            {this.props.email}
                          </a>
                        </div>
                      </div>
                    </div>

                  </MenuItem>
                  <MenuItem className="my-profile-menu">
                    <button className="btn btn-light logout-btn settings-btn" onClick={() => { this.props.history.push('/users/update-profile') }}>
                      <a to="#" color="white">
                        <div className="menu-icon profile-menu-icon"><FontAwesomeIcon
                          icon={["fa", "id-badge"]} /></div>
                        <span className="ml-1 mr-4"> My Profile</span>
                      </a>
                    </button>
                  </MenuItem>
                  <MenuItem className="setting-menu">
                    {this.props.isShowSetting &&
                      <button className="btn btn-light logout-btn settings-btn" onClick={() => { this.props.history.push(this.props.settingURL) }}>
                        <a to="#" color="white">
                          <div className="menu-icon setting-menu-icon"><FontAwesomeIcon
                            icon={["fa", "cog"]} /></div>
                          <span className="ml-1 mr-4"> Settings</span>
                        </a>
                      </button>
                    }
                  </MenuItem>
                  <MenuItem className="logout-menu">
                    <button className="btn btn-light logout-btn" onClick={() => { this.props.history.push('/logout') }}>
                      <a to="#" color="white">
                        <div className="menu-icon">
                          <FontAwesomeIcon icon={["fa", "sign-out-alt"]} /></div>
                                            &nbsp; &nbsp; &nbsp;<span> Logout</span>
                      </a>
                    </button>
                  </MenuItem>

                </Menu>
              </div>
            </div>
            {(window.location.pathname == '/dashboard' || window.location.pathname == '/screened-patient') &&
              <LeftMenuMobile dashboardLeftMenuMobileVisibleClass={dashboardLeftMenuVisibleClass}
                              isOpen={this.state.isOpen} 
                              openIconClass={openIconClass} 
                              toggleLeftMenuDesktop={this.toggleLeftMenuDesktop} 
                              leftMenuVisibleClass={leftMenuVisibleClass} 
                              scrollToBreakDown={this.scrollToBreakDown} 
                              globalSummaryAccess={this.state.globalSummaryAccess} 
                              sleepScreenerAccess={this.state.sleepScreenerAccess} 
                              isPapUser={this.props.isPapUser} breakdownClass={this.state.breakdownClass} trendsClass={this.state.trendsClass} detailsClass={this.state.detailsClass} />
            }
          </div>
        </header>
      </>
    );
  }
}
function mapStateToProps(state) {
  if (state.auth.user) {
    var parsedUserData = state.auth.user;
    let firstName = '';
    let imgPath = '';
    let isPapUser = state.auth.user.isPapUser;
    firstName = parsedUserData && parsedUserData.name ? parsedUserData.name : '';
    imgPath = parsedUserData.avatar ? parsedUserData.avatarWithFullPath : '';

    let insuranceOptions = [];
    let salesRepresentativesResponse = [];
    let maskTypeOptions = [];
    if (isPapUser == 1 && state.auth.fetchDashboardDetailresponse !== undefined) {
      if (state.auth.fetchDashboardDetailresponse.liInsuranceNameResponse !== undefined && state.auth.fetchDashboardDetailresponse.success == true) {
        state.auth.fetchDashboardDetailresponse.liInsuranceNameResponse.map((option) => {
          insuranceOptions.push({
            'value': option.payorName,
            'label': option.payorName
          })
        });
      }
    }
    if (isPapUser == 1 && state.auth.fetchDashboardDetailresponse !== undefined) {
      if (state.auth.fetchDashboardDetailresponse.liSalesRepresentativesResponse !== undefined && state.auth.fetchDashboardDetailresponse.success == true) {
        state.auth.fetchDashboardDetailresponse.liSalesRepresentativesResponse.map((option) => {
          salesRepresentativesResponse.push({
            'value': option.salesRep,
            'label': option.salesRep
          })
        });
      }
    }
    if (isPapUser == 1 && state.auth.fetchMaskTypeListResponse !== undefined) {
        if (state.auth.fetchMaskTypeListResponse.liMaskType !== undefined && state.auth.fetchMaskTypeListResponse.liMaskType !== null && state.auth.fetchMaskTypeListResponse.success == true) {
        state.auth.fetchMaskTypeListResponse.liMaskType.map((option) => {
            maskTypeOptions.push({
            'value': option.maskType,
            'label': option.maskType
          })
        });
      }
    }
    if (isPapUser == 0 && state.auth.nonPAPDashboardDetails !== undefined) {
        if (state.auth.nonPAPDashboardDetails.liInsuranceNameResponse !== undefined && state.auth.nonPAPDashboardDetails.success == true) {
        state.auth.nonPAPDashboardDetails.liInsuranceNameResponse.map((option) => {
          insuranceOptions.push({
            'value': option.payorName,
            'label': option.payorName
          })
        });
      }
    }
    if (isPapUser == 0 && state.auth.nonPAPDashboardDetails !== undefined) {
        if (state.auth.nonPAPDashboardDetails.liSalesRepresentativesResponse !== undefined && state.auth.nonPAPDashboardDetails.success == true) {
        state.auth.nonPAPDashboardDetails.liSalesRepresentativesResponse.map((option) => {
          salesRepresentativesResponse.push({
            'value': option.salesRep,
            'label': option.salesRep
          })
        });
      }
    }

    if(state.auth.fetchSalesRepresentativesresponse !== undefined) {
        if (state.auth.fetchSalesRepresentativesresponse.liSalesRepresentativesResponse !== undefined && state.auth.fetchSalesRepresentativesresponse.success == true) {
        state.auth.fetchSalesRepresentativesresponse.liSalesRepresentativesResponse.map((option) => {
          salesRepresentativesResponse.push({
            'value': option.salesRep,
            'label': option.salesRep
          })
        });
      }
    }

    let settingURL = '';
    if (state.auth.modulelist)
      if (state.auth.user.roleName == 'super-admin') {
        settingURL = '/users'
      }
      else {
        var index = state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('list-users-limited');
        if (index == -1) {
          if (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('list-users') != -1)
            settingURL = '/users'
          else if (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('add-user') != -1)
            settingURL = '/user/create'
          else if (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('list-roles') != -1)
            settingURL = '/roles'
          else if (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('add-role') != -1)
            settingURL = '/role/add'
          else if (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('list-logos') != -1)
            settingURL = '/logos'
        }
        else
          settingURL = '/users'
      }

    return {
      referralParam: state.auth.referralParam,
      organizationParam: state.auth.organizationParam,
      userFirstName: firstName,
      isShowSetting: state.auth.modulelist && ((state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('full-data') != -1 && state.auth.modulelist.length > 1) || (state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('full-data') == -1 && state.auth.modulelist.length > 0)) ? true : false,
      fullDataAccess: state.auth.modulelist && state.auth.modulelist.map(function (d) { return d['moduleName']; }).indexOf('full-data') != -1 ? true : false,
      imgPath: imgPath,
      email: parsedUserData.email,
      ptReferralKey: state.auth.ptReferralKey,
      ReferralKey: state.auth.ReferralKey,
      referralName: state.auth.Referral,
      referralNameResponse: state.auth.referralNameResponse,
      insuranceOptions: insuranceOptions,
      salesRepresentativesResponse: salesRepresentativesResponse,
      isFilterClear: state.auth.isFilterClear,
      isPapUser: isPapUser,
      globalSummaryAccess: state.auth.user.globalSummaryAccess,
      sleepScreenerAccess: state.auth.user.sleepScreenerAccess,
      isLoadingReferral: state.auth.isLoadingReferral,
      settingURL: settingURL,
      checkForMenuItemAccess: state.auth.checkForMenuItemAccessresponse != undefined ? state.auth.checkForMenuItemAccessresponse : [],
      maskTypeOptions: maskTypeOptions,
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchreferralNameRequest: (text) => dispatch(auth.actions.fetchreferralNameRequest(text)),
    loginAs: (data) => dispatch(auth.actions.loginAs(data)),
    login: (data) => dispatch(auth.actions.login(data)),
    saveSalesFilter: (data, isScrollToList) => dispatch(auth.actions.saveSalesFilter(data, isScrollToList)),
    fetchNonPAPSalesListByFilterRequest: (data) => dispatch(auth.actions.fetchNonPAPSalesListByFilterRequest(data)),
    fetchNonPAPSalesOrderDetailsListByStatusRequest: ({ ReferralParam, IsStatusNameParam, StatusNameParam }) => dispatch(auth.actions.fetchNonPAPSalesOrderDetailsListByStatusRequest({ ReferralParam, IsStatusNameParam, StatusNameParam })),
    fetchFilterList: () => dispatch(auth.actions.fetchFilterList()),
    fetchSalesOrderFilterListRequest: ({
      statusParam,
      salesRepParam,
      doctorParam,
      doctorNameParam,
      doctorFirstNameParam,
      doctorLastNameParam,
      insuranceParam,
      maskTypeParam,
      complianceRiskParam,
      equipmentTypeParam,
      daysSinceSetupParam,
      organizationParam,
      referralParam,
      // "limitParam": "10000",
      startDate,
      endDate,
      patientNameParam,
      patientFirstNameParam,
      patientNameLastParam,
      dateOfBirthParam,
      // "rowsToSkip": "0",
      orderByFieldParam,
      sortOrderParam,
      PageSize,
      PageNo
    }) => dispatch(auth.actions.fetchSalesOrderFilterListRequest({
      statusParam,
      salesRepParam,
      doctorParam,
      doctorNameParam,
      doctorFirstNameParam,
      doctorLastNameParam,
      insuranceParam,
      maskTypeParam,
      complianceRiskParam,
      equipmentTypeParam,
      daysSinceSetupParam,
      organizationParam,
      referralParam,
      // "limitParam": "10000",
      startDate,
      endDate,
      patientNameParam,
      patientFirstNameParam,
      patientNameLastParam,
      dateOfBirthParam,
      // "rowsToSkip": "0",
      orderByFieldParam,
      sortOrderParam,
      PageSize,
      PageNo
    })),
    clearFilter: (data) => dispatch(auth.actions.clearFilter(data)),
    fetchScreenedPatientListRequest: (referralParam) => {
      dispatch(auth.actions.fetchScreenedPatientListRequest(referralParam))
    },
    fetchSalesRepresentativesRequest: () => {
      dispatch(auth.actions.fetchSalesRepresentativesRequest())
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(onClickOutside(Topbar)));
